const LOCAL_URL = 'http://localhost:8082';
// defaults to prod url (so we can test any released ui against prod api using direct cloudfront url)
const AWS_URL_PREFIX = window.origin.includes('order.smart-dispensary') ? window.origin.split('order.smart-dispensary')[0] : 'https://';
const AWS_URL = `${AWS_URL_PREFIX}api.greenstop-us.com`;

const URL = process.env.NODE_ENV === 'development' ? LOCAL_URL : AWS_URL;

export default require('axios').create({ baseURL: URL + '/public' });
